module.exports = __webpack_public_path__ + "static/media/IsHere.8fa1c1c1.svg";